import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Checkbox,
  FormControlLabel,
  Typography,
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid,
} from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';

import Paginator from '../../common/Paginator';
import Loader from '../../common/Loader';

const MessageBatches = (props) => {
  const {
    data,
    count,
    loading,
    filter,
    onBatchSelect,
    onFilterChange,
    onRefresh,
  } = props;

  const [onDate, setOnDate] = useState(filter.onDate || new Date());
  const [customer, setCustomer] = useState(filter.customer || '');
  const [user, setUser] = useState(filter.user || '');
  const [withErrors, setWithErrors] = useState(filter.withErrors || false);
  const [page, setPage] = useState(filter.page || 1);

  let timer;
  const filterUpdate = (_then) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      console.log('filterUpdate');
      _then();
    }, 350);
  };

  useEffect(() => {
    console.log('useEffect', onDate, customer, user, withErrors, page);
    onFilterChange({
      onDate,
      customer,
      user,
      withErrors,
      page,
    });
  }, [onDate, customer, user, withErrors, page]);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 2,
        }}
      >
        <Typography variant="h3">Message Log</Typography>

        <Button
          variant="contained"
          color="secondary"
          onClick={() => onRefresh()}
        >
          Refresh
        </Button>
      </Box>

      <Grid container spacing={2} sx={{ marginBottom: 2 }}>
        <Grid size={{ xs: 12, md: 6, lg: 3 }}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DatePicker
              label="Since"
              value={moment(onDate)}
              onChange={(value) => {
                filterUpdate(() => setOnDate(value));
              }}
              format="DD/MMM/YYYY"
              disableFuture
              fullWidth
              slotProps={{
                textField: {
                  size: 'small',
                  fullWidth: true,
                },
              }}
            />
          </LocalizationProvider>
        </Grid>

        <Grid size={{ xs: 12, md: 6, lg: 3 }}>
          <TextField
            type="text"
            label="Customer"
            variant="outlined"
            defaultValue={customer}
            fullWidth
            onChange={(e) => {
              filterUpdate(() => setCustomer(e.target.value));
            }}
            size="small"
          />
        </Grid>

        <Grid size={{ xs: 12, md: 6, lg: 4 }}>
          <TextField
            type="text"
            label="User"
            variant="outlined"
            defaultValue={user}
            onChange={(e) => {
              filterUpdate(() => setUser(e.target.value));
            }}
            fullWidth
            size="small"
          />
        </Grid>

        <Grid size={{ xs: 12, md: 6, lg: 2 }}>
          <FormControlLabel
            fullWidth
            control={
              <Checkbox
                checked={withErrors}
                onChange={(e) => {
                  filterUpdate(() => setWithErrors(!e.target.checked));
                }}
              />
            }
            label="With Errors"
            sx={{ margin: 0 }}
          />
        </Grid>
      </Grid>

      {loading ? (
        <Loader />
      ) : (
        <>
          <TableContainer sx={{ marginBottom: 4, overflowX: 'auto' }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Last Updated</TableCell>
                  <TableCell>Customer</TableCell>
                  <TableCell>User</TableCell>
                  <TableCell>Counts</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={4} className="text-center">
                      No data found
                    </TableCell>
                  </TableRow>
                )}
                {data.map((item, index) => (
                  <TableRow
                    key={index}
                    onClick={() => onBatchSelect(item)}
                    hover
                  >
                    <TableCell>
                      {new Intl.DateTimeFormat('en-us', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric',
                        second: 'numeric',
                      }).format(new Date(item.last_updated))}
                    </TableCell>
                    <TableCell>{item.customer_name}</TableCell>
                    <TableCell>{item.customer_user_name}</TableCell>
                    <TableCell>
                      <Typography
                        component="span"
                        sx={{ color: 'success.light' }}
                        title="Success"
                      >
                        {item.success_count}
                      </Typography>
                      {' - '}
                      <Typography component="span" color="error" title="Failed">
                        {item.failure_count}
                      </Typography>
                      {' / '}
                      <Typography component="span" title="Total">
                        {item.message_count}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {count > 10 && (
            <Paginator
              itemCount={count}
              changeEvent={(page) => {
                filterUpdate(() => setPage(page));
              }}
            />
          )}
        </>
      )}
    </>
  );
};

export default MessageBatches;
